<div class="spinner-container">
    <mat-spinner diameter="50"></mat-spinner>
</div>
